"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 4.66667H11.9107C12.3727 4.24539 12.7389 3.72974 12.9843 3.15464C13.2298 2.57955 13.3488 1.95843 13.3333 1.33333H12C12 3.254 10.686 4.20467 9.232 4.53333C9.66858 3.75453 9.93064 2.89013 10 2C10 1.46957 9.78929 0.960859 9.41421 0.585786C9.03914 0.210714 8.53043 0 8 0C7.46957 0 6.96086 0.210714 6.58579 0.585786C6.21071 0.960859 6 1.46957 6 2C6.06937 2.89013 6.33142 3.75453 6.768 4.53333C5.314 4.20467 4 3.254 4 1.33333H2.66667C2.6512 1.95843 2.77021 2.57955 3.01567 3.15464C3.26112 3.72974 3.62727 4.24539 4.08933 4.66667H2C1.46957 4.66667 0.960859 4.87738 0.585786 5.25245C0.210714 5.62753 0 6.13623 0 6.66667L0 9.33333H1.33333V16H14.6667V9.33333H16V6.66667C16 6.13623 15.7893 5.62753 15.4142 5.25245C15.0391 4.87738 14.5304 4.66667 14 4.66667ZM8 1.33333C8.17681 1.33333 8.34638 1.40357 8.47141 1.5286C8.59643 1.65362 8.66667 1.82319 8.66667 2C8.58619 2.70855 8.35915 3.39261 8 4.00867C7.64085 3.39261 7.41381 2.70855 7.33333 2C7.33333 1.82319 7.40357 1.65362 7.5286 1.5286C7.65362 1.40357 7.82319 1.33333 8 1.33333ZM1.33333 6.66667C1.33333 6.48986 1.40357 6.32029 1.5286 6.19526C1.65362 6.07024 1.82319 6 2 6H7.33333V8H1.33333V6.66667ZM2.66667 9.33333H7.33333V14.6667H2.66667V9.33333ZM13.3333 14.6667H8.66667V9.33333H13.3333V14.6667ZM14.6667 8H8.66667V6H14C14.1768 6 14.3464 6.07024 14.4714 6.19526C14.5964 6.32029 14.6667 6.48986 14.6667 6.66667V8Z",
    fill: fill
  }));
};

exports["default"] = _default;